import React, { useEffect, useState } from "react";
//import Clienthomemenu from "../Menus/Clienthomemenu";
import Setftestexammodule from "./Setftestexammodule";
import Readallquestion from "./Readallquestion";
import Adminhomemenu from "../Menus/Adminhomemenu";

export default function Reading() {
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [topics, setTopics] = useState([]);

  const [questions, setQuestions] = useState([]);
  const [startExam, setStartExam] = useState(false);
  const [loadingSubject, setLoadingSubject] = useState(false);
  const [loading, setLoading] = useState(false);
  const [testid, setTestid] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));
  //  const LANGUAGE_ID=user?.LANGUAGE_ID;
  const uid = user?.UID;

  const LANGUAGE_ID = localStorage.getItem("language");
  /* ================= SUBJECT LIST ================= */
  useEffect(() => {
    fetchSubjects();
  }, []);

  const fetchSubjects = async () => {
    try {
      setLoadingSubject(true);
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_SUBJECT}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: user?.TRADE_ID,
          TRADE_NAME: user?.TRADE_NAME,
        }),
      });

      const data = await res.json();

      if (data.res === "Success") {
        setSubjects(data.data);

        if (data.data.length > 0) {
          setSelectedSubject(data.data[0].TRADE_ID); // default first
        }
      }
    } catch (err) {
      alert("Server Error");
      console.error(err);
    }
    setLoadingSubject(false);
  };

  /* ================= LOAD TOPICS ON SUBJECT CHANGE ================= */
  useEffect(() => {
    if (selectedSubject) {
      fetchTopics(selectedSubject);
    }
  }, [selectedSubject]);

  const fetchTopics = async (tradeId) => {
    try {
      setLoading(true);
      const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_LIST_OF_TOPIC}`;

      const res = await fetch(path, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          TRADE_ID: tradeId, // ✅ IMPORTANT
        }),
      });

      const data = await res.json();

      if (data.res === "success") {
        setTopics(data.data);
      } else {
        setTopics([]);
      }
    } catch (err) {
      console.error(err);
    }
    setLoading(false);
  };

  /* ================= START EXAM ================= */
  const handleStartTest = (topic) => {
    setLoading(true);

    const payload = {
      TRADE_ID: selectedSubject,
      TOPIC_UID: topic.TOPIC_UID,
      NUM_OF_QUE: 1000000000,
      LANGUAGE_ID: LANGUAGE_ID,
    };
    const path = `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_GET_QUESTION1}`;

    fetch(path, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.res === "success") {
          setQuestions(data.data);
          setTestid(data.TEST_UID || "");
          setStartExam(true);
        } else {
          alert(data.msg || "No questions found");
        }
        setLoading(false);
      })
      .catch(() => {
        alert("Server error");
        setLoading(false);
      });
  };

  /* ================= OPEN EXAM ================= */
  if (startExam) {
    return (
      <Readallquestion questions={questions} testid={testid} userid={uid} />
    );
  }

  return (
    <>
      <Adminhomemenu title="EasyITI" testhistory="testhistory" />
      {loadingSubject ? (
        <div className="text-center my-3">
          <div className="spinner-border text-success" />
        </div>
      ) : subjects.length === 0 ? (
        <div className="text-center mt-5">
          <div className="card p-4 shadow-sm">
            <h5>⚠ Subjects Load Failed</h5>
            <p>Please refresh to fetch subjects</p>
            <button className="btn btn-primary " onClick={() => fetchSubjects()}>
              Refresh Subjects
            </button>
          </div>
        </div>
      ) : (
        <div
        className="container"
        style={{
          paddingTop: "90px",
          height: "auto",
        }}
      >
          {/* SUBJECT */}
          <label className="form-label">Select Subject</label>
          <select
            className="form-select"
            value={selectedSubject}
            onChange={(e) => setSelectedSubject(e.target.value)}
          >
            {subjects.map((item) => (
              <option key={item.TRADE_ID} value={item.TRADE_ID}>
                {item.TRADE_NAME}
              </option>
            ))}
          </select>

          {/* TOPICS */}
           {loading && (
            <div className="text-center mt-3">
              <div className="spinner-border text-primary" />
              <p>Loading Questions...</p>
            </div>
          )}
          <div style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <div className="row mt-4">
              {topics.map((topic) => (
                <div className="col-md-4 mb-3" key={topic.TOPIC_UID}>
                  <div
                    className="card p-3 shadow-sm text-center topic-card"
                    style={{ cursor: "pointer" }}
                    onClick={() => handleStartTest(topic)}
                  >
                    <h6>{topic.TOPIC_NAME}</h6>
                    <small>Click to Read</small>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {loading && (
            <div className="text-center mt-3">
              <div className="spinner-border text-primary" />
              <p>Loading Exam...</p>
            </div>
          )}
        </div>
      )}
    </>
  );
}
